import api from '../config/api';

export const listCompanyInvites = async (params) => {
  const res = await api.get('/company/invites', { params });
  return res.data;
};

export const createCompanyInvite = async (payload) => {
  const res = await api.post('/company/invites', payload);
  return res.data;
};

export const listCompanyVips = async (params) => {
  const res = await api.get('/company/vips', { params });
  return res.data;
};

export const createCompanyVip = async (payload) => {
  const res = await api.post('/company/vips', payload);
  return res.data;
};
